<app-header></app-header>
<div class="main">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
